import {
  gray5,
  gray7,
  mainColor,
  mainDark2Color,
  white,
} from "assets/styleUtils";
import { GuideBox, Header } from "components";
import _ from "lodash";
import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  etcRecombinationListState,
  recombinationListState,
} from "recoil/company";
import { headerState } from "recoil/header";
import { getPointApplyDetail } from "store/data/user";
import { post } from "utils/ApiUtil";
import { getParameterObject } from "utils/common";
import styles from "./style.module.css";

export interface IPointPrevList {
  no: number;
  user_no: number;
  name: string;
  contructor_name: string;
  phone: string;
  join_day: string;
  point: number;
  payment_day: string;
  img_url: string;
  pay_yn: "N" | "Y";
  del_yn: "N" | "Y";
  createdAt: string;
  updatedAt: string;
  createdDt: string;
  updatedDt: string;
  assurance_people?: number;
  wedding_day?: string;
}

const PointApplyPage = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { company, type, no, companyNo, category } = getParameterObject({
    url: search,
  });
  const decodedTxt = decodeURIComponent(company);
  const fix = type === "fix";
  const weddinghall = category === "weddinghall";
  const [pointPrevList, setPointPrevList] = useState<IPointPrevList>();
  const noPaid = fix && !!no && pointPrevList?.pay_yn === "N";
  const isPaid = fix && !!no && pointPrevList?.pay_yn === "Y";

  const [name, setName] = useState("");
  const [contructorName, setContructorName] = useState(
    (decodedTxt !== "undefined" && decodedTxt) || "",
  );
  const [phone, setPhone] = useState("");
  const [joinDay, setJoinDay] = useState("");
  const [weddingDay, setWeddingDay] = useState("");
  const [guarantors, setGuarnators] = useState<number>();
  const [imgUrl, setImgUrl] = useState<string>("");
  const [file, setFile] = useState<File | null>(null);
  const nameRef = useRef<HTMLInputElement | null>(null);
  const contructorNameRef = useRef<HTMLInputElement | null>(null);
  const phoneRef = useRef<HTMLInputElement | null>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const contructorDateRef = useRef<HTMLInputElement | null>(null);
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const weddingDayRef = useRef<HTMLInputElement | null>(null);
  const guarantorsRef = useRef<HTMLInputElement | null>(null);

  const recombinationList = useRecoilValue(recombinationListState);
  const etcRecombinationList = useRecoilValue(etcRecombinationListState);
  const [successApply, setSuccessApply] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [selectCompanyNo, setSelectCompanyNo] = useState(
    Number(companyNo) || 0,
  );
  // 예약해놓은 업체들 추출 함수
  const filteredRecombinationList = recombinationList.filter(
    (item) => item.status !== 3 && item.status !== 0,
  );
  const filteredEtcRecombinationList = etcRecombinationList.filter(
    (item) => item.status !== 3 && !item.counsel_cancel_day,
  );
  const combinedList = weddinghall
    ? filteredRecombinationList
    : filteredEtcRecombinationList;

  const [showList, setShowList] = useState(false);
  const setHeader = useSetRecoilState(headerState);

  setHeader({
    isVisible: true,
    title: isPaid
      ? "계약포인트 상세조회"
      : noPaid
      ? "계약포인트 신청 수정"
      : "계약포인트 신청",
    url: "-1",
  });

  const isComplete =
    name.length > 1 &&
    phone.length === 11 &&
    !!phone.match(/^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/) &&
    !!joinDay &&
    !!imgUrl &&
    (weddinghall ? !!weddingDay && !!guarantors : true) &&
    (fix ? !!pointPrevList?.contructor_name : contructorName.length > 1);

  const errorMsg = (() => {
    if (name.length < 1) {
      return "계약자 이름을 입력해주세요.";
    }
    if (contructorName.length < 1) {
      return "업체명을 입력해주세요.";
    }
    if (
      phone.length != 11 ||
      !phone.match(/^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/)
    ) {
      return "전화번호를 정확히 입력해주세요.";
    }
    if (!joinDay) {
      return "날짜를 선택해주세요.";
    }
    if (!imgUrl) {
      return "사진을 업로드해주세요.";
    }
  })();

  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  function phoneCheck(e: React.ChangeEvent<HTMLInputElement>) {
    const input = e.target;
    const maxLength = 11;

    if (input.value.length > maxLength) {
      input.value = input.value.slice(0, maxLength);
    }
    setPhone(e.target.value);
  }

  const onUploadImage = useCallback(
    async (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.target.files) {
        setFile(e.target.files[0]);
      }
    },
    [],
  );
  const uploadImage = async () => {
    if (file) {
      const formData = new FormData();
      formData.append("files", file);

      try {
        const response = await post("/api/utils/communityimgs", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        setImgUrl(response.data.imglist);
      } catch (error) {
        toast.error("업로드 오류가 발생했습니다");
      }
    }
  };
  const throttleCreate = _.debounce(create, 1000);
  const throttleEdit = _.throttle(edit, 1000);

  async function create() {
    const contractInfo = combinedList.filter(
      (data) => data.no === selectCompanyNo,
    );
    setSuccessApply(true);

    try {
      const {
        data: { result },
        success,
        message,
      } = await post("/api/user/createPointApply", {
        name,
        contructor_name: contructorName,
        phone,
        join_day: joinDay,
        img_url: imgUrl,
        wedding_day: weddingDay,
        assurance_people: guarantors,
        contructor_no: contractInfo[0].contructor_no,
        estimate_no: contractInfo[0].estimate_no,
        estimate_sub_no: contractInfo[0].no,
        status: Number(contractInfo[0]?.status),
      });
      if (success) {
        toast.success(message);
        setTimeout(() => {
          navigate(-1);
        }, 3000);
      } else {
        toast.error(message);
      }
    } catch (error) {
      alert(error);
      toast.error("오류가 발생했습니다");
      console.error("InsertPointApplyPage create error", error);
    }
  }
  async function edit() {
    try {
      const {
        data: { result },
        success,
        message,
      } = await post("/api/user/updatePointApply", {
        no,
        name,
        contructor_name: contructorName,
        phone,
        join_day: joinDay,
        img_url: imgUrl,
        wedding_day: weddingDay,
        assurance_people: guarantors,
      });
      if (success) {
        toast.success(message);
        setSuccessApply(true);
        setTimeout(() => {
          navigate(-1);
        }, 3000);
      } else {
        toast.error(message);
      }
    } catch (error) {
      toast.error("오류가 발생했습니다");
      console.error("InsertPointApplyPage create error", error);
    }
  }

  const formatContractorName = (
    name: string = "",
    isAdvertising: boolean,
    limit = 5,
  ): string => {
    if (isAdvertising && name.length > limit) {
      return `${name.slice(0, limit)}...`;
    }
    return name;
  };

  useEffect(() => {
    if (file) {
      uploadImage();
    }
  }, [file]);

  useEffect(() => {
    function handleClickOutside(event: Event) {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setShowList(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  async function getPrevList() {
    try {
      const {
        data: { result },
        success,
      } = await getPointApplyDetail(no);
      if (success) {
        setPointPrevList(result);
      }
    } catch (error) {
      console.error("MyPointPrevList error", error);
    } finally {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    if (fix) {
      getPrevList();
    }
  }, []);

  useEffect(() => {
    if (pointPrevList) {
      setName(pointPrevList.name);
      setContructorName(pointPrevList.contructor_name);
      setPhone(pointPrevList.phone);
      setJoinDay(pointPrevList.join_day);
      setImgUrl(pointPrevList.img_url);
      setWeddingDay(pointPrevList.wedding_day || "");
      setGuarnators(pointPrevList.assurance_people || 0);
    }
  }, [pointPrevList]);
  return (
    <div style={{ height: "100vh" }}>
      <div
        style={{
          flex: 1,
          padding: "0px 30px ",
          marginTop: "20px",
        }}
      >
        <div
          style={{
            padding: "0 16px",
            border: `1px solid ${gray7}`,
            borderRadius: 4,
          }}
        >
          <div className={styles.textContainer}>
            <div className={styles.inputTitlestyle}>
              <span style={{ fontWeight: "500" }}>계약자</span>
            </div>
            <div className={styles.inputstyle}>
              {isPaid ? (
                <input
                  className={styles.paidBackground}
                  value={pointPrevList?.name || ""}
                />
              ) : (
                <input
                  ref={nameRef}
                  placeholder="이름 입력"
                  onChange={(e) => setName(e.target.value)}
                  defaultValue={pointPrevList?.name || name}
                />
              )}
            </div>
          </div>
          <div className={styles.textContainer}>
            <div className={styles.inputTitlestyle}>
              <span style={{ fontWeight: "500" }}>업체명</span>
            </div>
            <div className={styles.inputstyle}>
              {!!fix ? (
                <input
                  className={styles.paidBackground}
                  value={pointPrevList?.contructor_name || ""}
                />
              ) : (
                <input
                  ref={contructorNameRef}
                  placeholder={
                    combinedList.length > 0
                      ? "업체명 선택"
                      : "선택가능한 업체가 없습니다."
                  }
                  value={contructorName}
                  onClick={() =>
                    combinedList.length > 0 && setShowList(!showList)
                  }
                  readOnly
                />
              )}
              {!!showList && (
                <div ref={wrapperRef} className={styles.showList}>
                  {combinedList.map((item, index) => (
                    <div
                      key={index}
                      className={styles.showItem}
                      onClick={() => {
                        if (item.advertising_yn === "Y") {
                          return toast.error("포인트 미지급업체입니다.");
                        }
                        setSelectCompanyNo(item.no);
                        setContructorName(item.contructor_name);
                        setShowList(false);
                      }}
                    >
                      <div>
                        {formatContractorName(
                          item.contructor_name,
                          item.advertising_yn === "Y",
                        )}
                      </div>
                      {item.advertising_yn === "Y" && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: mainDark2Color,
                            borderRadius: "5px",
                            padding: "2px 5px 0 5px",
                            marginRight: "-8px",
                            color: white,
                          }}
                        >
                          포인트 미지급 업체
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <div className={styles.textContainer}>
            <div className={styles.inputTitlestyle}>
              <span style={{ fontWeight: "500" }}>전화번호</span>
            </div>
            <div className={styles.inputstyle}>
              {isPaid ? (
                <input
                  className={styles.paidBackground}
                  value={pointPrevList?.name || ""}
                />
              ) : (
                <input
                  ref={phoneRef}
                  placeholder="전화번호 입력(- 제외)"
                  type="number"
                  maxLength={11}
                  onChange={phoneCheck}
                  defaultValue={pointPrevList?.phone || phone}
                />
              )}
            </div>
          </div>
          <div className={styles.textContainer}>
            <div className={styles.inputTitlestyle}>
              <span style={{ fontWeight: "500" }}>계약일자</span>
            </div>
            <div className={styles.inputstyle}>
              {isPaid ? (
                <input
                  className={styles.paidBackground}
                  value={pointPrevList?.name || ""}
                />
              ) : (
                <input
                  type="date"
                  ref={contructorDateRef}
                  onChange={(e) => setJoinDay(e.target.value)}
                  defaultValue={pointPrevList?.join_day || joinDay || ""}
                />
              )}
            </div>
          </div>
          {weddinghall && (
            <>
              <div className={styles.textContainer}>
                <div className={styles.inputTitlestyle}>
                  <span style={{ fontWeight: "500" }}>예식일자</span>
                </div>
                <div className={styles.inputstyle}>
                  {isPaid ? (
                    <input
                      className={styles.paidBackground}
                      value={pointPrevList?.name || ""}
                    />
                  ) : (
                    <input
                      type="date"
                      ref={weddingDayRef}
                      onChange={(e) => setWeddingDay(e.target.value)}
                      defaultValue={
                        pointPrevList?.wedding_day || weddingDay || ""
                      }
                    />
                  )}
                </div>
              </div>
              <div className={styles.textContainer}>
                <div className={styles.inputTitlestyle}>
                  <span style={{ fontWeight: "500" }}>보증인원</span>
                </div>
                <div className={styles.inputstyle}>
                  {isPaid ? (
                    <input
                      className={styles.paidBackground}
                      value={pointPrevList?.assurance_people}
                    />
                  ) : (
                    <input
                      placeholder="숫자만 입력해주세요(ex. 250)"
                      ref={guarantorsRef}
                      type="number"
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, "");
                        setGuarnators(Number(value));
                        e.target.value = value;
                      }}
                      defaultValue={pointPrevList?.assurance_people}
                    />
                  )}
                </div>
              </div>
            </>
          )}
          <div className={styles.textContainer}>
            <div className={styles.inputTitlestyle}>
              <span style={{ fontWeight: "500" }}>계약서 첨부</span>
            </div>
            <div
              style={{
                padding: "5px 30px ",
                width: "100%",
                backgroundColor: white,
              }}
            >
              <div style={{ display: "flex" }}>
                <div onClick={handleClick}>
                  <img
                    src={"/images/photomain.png"}
                    alt="Upload Photo"
                    style={{ cursor: "pointer" }}
                  />
                  {!isPaid && (
                    <input
                      ref={fileInputRef}
                      type="file"
                      name="image"
                      accept=".jpg, .png, .jpeg, .gif, image/jpg, image/png, image/jpeg, image/gif"
                      onChange={onUploadImage}
                      multiple
                      style={{ display: "none", direction: "rtl" }}
                    />
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "10px",
                  }}
                >
                  {pointPrevList?.img_url || imgUrl ? 1 : 0}/1
                </div>
              </div>
              <div>
                {(!!imgUrl || !!pointPrevList?.img_url) && (
                  <div
                    style={{
                      marginTop: "10px",
                      width: "100%",
                    }}
                  >
                    <div>
                      <img
                        style={{
                          height: "84px",
                          width: "84px",
                          borderRadius: "4px",
                          marginRight: "8px",
                        }}
                        src={imgUrl}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              marginBottom: "20px",
            }}
          >
            {!isPaid && (
              <div
                style={{
                  backgroundColor:
                    !successApply && !!isComplete ? mainColor : gray5,
                  padding: "10px",
                  width: "100px",
                  display: "flex",
                  justifyContent: "center",
                  color: white,
                  borderRadius: "10px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  !successApply && !!isComplete
                    ? noPaid
                      ? throttleEdit()
                      : throttleCreate()
                    : toast.error(errorMsg);
                }}
              >
                {!successApply
                  ? noPaid
                    ? "수정하기"
                    : "신청하기"
                  : "신청완료"}
              </div>
            )}
          </div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginTop: "20px",
          width: "100%",
          // height: " calc(100vh - 375px)",
        }}
      >
        {weddinghall ? (
          <GuideBox
            title="웨딩홀 안내"
            color="white"
            pdt={10}
            list={[
              "메이크마이웨딩을 통한 '최초' 예약일 경우에만 웨딩홀 계약 시 캐시백 지급 신청이 가능하며, 타경로/타업체를 통한 예약 또는 직접 업체에 연락을 하신 경우에는 캐시백 지급이 불가합니다.",
              "계약 확인을 위해 좌측 하단의 사진 첨부 기능을 이용하여 증빙 자료(ex. 계약서)를 함께 첨부 부탁 드립니다. (*성함/연락처/웨딩홀명/보증 인원/최종 계약일/예식 일정을 제외한 개인 정보는 반드시 가리고 첨부해주세요!)",
              "증빙 자료가 첨부되지 않아 계약 확인이 불가할 경우 캐시백 지급이 어려울 수 있습니다.",
              "캐시백은 5만원 이상으로 제세공과금 22% 공제 후 <span>예식 종료 후 익월 말에 순차 지급됩니다.</span>",
              "비 제휴업체의 경우 메이크마이웨딩을 통한 예약일지라도 캐시백 지급이 불가할 수 있습니다. (사전 안내 사항입니다)",
            ]}
          />
        ) : (
          <GuideBox
            title="기타 제휴업체 안내"
            color="white"
            pdt={10}
            list={[
              "메이크마이웨딩 어플을 통한 '최초' 예약일 경우에만 신청이 가능하며, 타경로/타업체를 통한 예약 또는 직접 업체에 연락을 하신 경우에는 포인트 지급이 불가합니다.",
              "포인트 지급은 신청일로부터 영업일 기준 3~7일 정도 소요됩니다.",
              "계약 확인을 위해 좌측 하단의 사진 첨부 기능을 이용하여 증빙 자료를 첨부해 주세요. (계약서 또는 계약금, 예약금 입금내역)",
              "증빙 자료가 첨부되지 않아 계약 확인이 불가할 경우 포인트 지급이 어려울 수 있습니다.",
              "메이크마이웨딩 카페 제휴업체일지라도 '어플'을 통한 예약 건이 아닌 경우 포인트 지급은 불가합니다. (카페/어플 별개 운영)",
            ]}
          />
        )}
      </div>
      <ToastContainer
        position="bottom-center"
        limit={1}
        closeButton={false}
        autoClose={1000}
        theme="light"
      />
    </div>
  );
};

export default PointApplyPage;
